export function LoadingSpinner({ label = "Loading…" }: { label?: string }) {
  return (
    <div className="flex justify-center py-24">
      <div className="bg-card border-border flex items-center gap-2.5 rounded-full border px-4 py-2">
        <span className="border-border border-t-foreground h-4 w-4 animate-spin rounded-full border-2" />
        <span className="text-muted-foreground text-xs">{label}</span>
      </div>
    </div>
  );
}

export function OverlayLoadingSpinner({ label = "Loading…" }: { label?: string }) {
  return (
    <div className="pointer-events-none absolute inset-0 z-10 flex items-start justify-center pt-24">
      <div className="bg-card border-border flex items-center gap-2.5 rounded-full border px-4 py-2 shadow-lg">
        <span className="border-border border-t-foreground h-4 w-4 animate-spin rounded-full border-2" />
        <span className="text-muted-foreground text-xs">{label}</span>
      </div>
    </div>
  );
}
